import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";
import { IDemandPayload } from "../../interface/IDemand";

export const featureImportanceApi =  createApi({
    reducerPath: 'featureImportanceApi',
    baseQuery: axiosBaseQuery(),
    endpoints: (builder)=>({
        featureImportanceFilterDropdown: builder.mutation({
            query:(payload: IDemandPayload)=>({
                url: "/futureImportanceFilterDropdown",
                method: "POST",
                data: payload,
            })
        }),
        featureImportanceLineChart: builder.mutation({
            query:(payload: IDemandPayload)=>({
                url:"/futureImportanceLineChat",
                method:"POST",
                data: payload
            })
        }),
        featureImportanceTableData: builder.mutation({
            query:(payload: IDemandPayload)=>({
                url: "/futureImportanceTableData",
                method: 'POST',
                data: payload
            })
        })
    })
})

export const {
    useFeatureImportanceFilterDropdownMutation,
    useFeatureImportanceLineChartMutation,
    useFeatureImportanceTableDataMutation,
} = featureImportanceApi;